import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { ShieldCheck, ArrowRight } from "@phosphor-icons/react";
import { endpoints, adminToken } from "@/lib/api";
import { TEST_IDS } from "@/constants/testIds";

export default function AdminLogin() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [busy, setBusy] = useState(false);
    const navigate = useNavigate();

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        try {
            const r = await endpoints.adminLogin({ email, password });
            adminToken.set(r.token);
            toast.success("Signed in");
            navigate("/admin");
        } catch (_) {
            toast.error("Invalid credentials");
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center bg-[#FCFCFB] px-4">
            <form
                onSubmit={submit}
                data-testid={TEST_IDS.adminLoginForm}
                className="w-full max-w-md border border-neutral-200 bg-white rounded-sm p-8"
            >
                <div className="w-12 h-12 mx-auto border border-[#6B46C1] bg-[#F5F3FF] flex items-center justify-center rounded-sm mb-4">
                    <ShieldCheck size={22} weight="duotone" className="text-[#6B46C1]" />
                </div>
                <div className="label-caps text-center mb-2">Admin portal</div>
                <h1 className="font-serif text-3xl text-center font-light">
                    Sign in
                </h1>
                <p className="text-xs text-neutral-500 text-center mt-2">
                    Only administrators can review and approve community submissions.
                </p>

                <div className="mt-6 space-y-4">
                    <div>
                        <label className="label-caps block mb-1.5">Email</label>
                        <input
                            data-testid={TEST_IDS.adminEmailInput}
                            type="email"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="admin@sdx.local"
                            className="w-full px-3 py-2 border border-neutral-300 text-sm rounded-sm outline-none focus:border-[#6B46C1]"
                        />
                    </div>
                    <div>
                        <label className="label-caps block mb-1.5">Password</label>
                        <input
                            data-testid={TEST_IDS.adminPasswordInput}
                            type="password"
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="w-full px-3 py-2 border border-neutral-300 text-sm rounded-sm outline-none focus:border-[#6B46C1]"
                        />
                    </div>
                </div>

                <button
                    type="submit"
                    data-testid={TEST_IDS.adminLoginButton}
                    disabled={busy}
                    className="btn-primary w-full mt-6 justify-center text-sm py-2.5 disabled:opacity-40"
                >
                    {busy ? "Signing in…" : "Sign in"} <ArrowRight size={14} />
                </button>

                <div className="text-[11px] text-neutral-400 text-center mt-4">
                    Not an admin? <Link to="/" className="underline underline-offset-2">
                        Go back to SustainDex
                    </Link>.
                </div>
            </form>
        </div>
    );
}
